export const CRITICAL_REPORT_GROUPS = [
  'tree',
  'site',
  'features',
  'inconveniences',
  'cache',
]

export const FAILED_ACTION_TYPES = new Set([
  'error',
  'notCreated',
  'Not created',
  'Not deleted',
  'validation',
])

const emptyGroup = () => ({
  ok: true,
  message: '',
  saved: [],
  failed: [],
})

export function createOperationReport(overrides = {}) {
  const report = {
    tree: emptyGroup(),
    site: emptyGroup(),
    features: emptyGroup(),
    inconveniences: emptyGroup(),
    cache: emptyGroup(),
    photos: emptyGroup(),
    pseudonyms: emptyGroup(),
  }

  Object.entries(overrides).forEach(([key, value]) => {
    report[key] = {
      ...(report[key] || emptyGroup()),
      ...(value || {}),
      saved: value?.saved || report[key]?.saved || [],
      failed: value?.failed || report[key]?.failed || [],
    }
  })

  return report
}

export function getReportFromResponse(response) {
  return response?.operationReport?.report || response?.report || null
}

export function actionFailed(action) {
  return FAILED_ACTION_TYPES.has(action?.typeAction) || FAILED_ACTION_TYPES.has(action?.action)
}

export function actionsHaveFailures(actions = []) {
  return Array.isArray(actions) && actions.some(actionFailed)
}

export function hasCriticalFailures(report, groups = CRITICAL_REPORT_GROUPS) {
  if (!report) return false
  return groups.some(groupName => {
    const group = report[groupName]
    if (!group) return false
    return group.ok === false || (Array.isArray(group.failed) && group.failed.length > 0)
  })
}

export function formatOperationMessage(response, fallbackMessage) {
  if (response?.message) return response.message
  if (response?.operationReport?.message) return response.operationReport.message

  const report = getReportFromResponse(response)
  if (!report) return fallbackMessage

  const messages = Object.values(report)
    .flatMap(group => [
      group?.ok === false ? group.message : null,
      ...(Array.isArray(group?.failed)
        ? group.failed.map(item => item?.message || item?.field || item?.key)
        : []),
    ])
    .filter(Boolean)

  return messages[0] || fallbackMessage
}

export function validateOperationResponse(
  response,
  {
    successActions = [],
    fallbackMessage = 'Error al procesar la operación.',
    criticalGroups = CRITICAL_REPORT_GROUPS,
  } = {},
) {
  const report = getReportFromResponse(response)
  const actionOk =
    successActions.length === 0 || successActions.includes(response?.action)
  const explicitOk =
    response?.ok === true || response?.operationReport?.ok === true

  if (!response || response?.ok === false || response?.operationReport?.ok === false) {
    return {
      ok: false,
      message: formatOperationMessage(response, fallbackMessage),
      report,
    }
  }

  if (!actionOk && !explicitOk) {
    return {
      ok: false,
      message: formatOperationMessage(response, fallbackMessage),
      report,
    }
  }

  if (hasCriticalFailures(report, criticalGroups)) {
    return {
      ok: false,
      message: formatOperationMessage(response, fallbackMessage),
      report,
    }
  }

  return {
    ok: true,
    message: response?.message || '',
    report,
  }
}
